import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { AppRedirectService } from 'src/app/services/app-redirect.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-smart-app-banner',
  templateUrl: './smart-app-banner.component.html',
  styleUrls: ['./smart-app-banner.component.scss']
})
export class SmartAppBannerComponent {
  translationData: any;
  showSpinner$!: Observable<boolean>;

  constructor(private readonly translationService: TranslationService, 
    private readonly appRedirectService: AppRedirectService) { }

  isShowSpinner: boolean = false;

  ngOnInit() {
    this.translationService.getTranslationDataAsObservable().subscribe(
      (translationData: any) => {
        this.translationData = translationData;
      }
    )
  }

   triggerGoToApp() {
    this.showSpinner$ = this.appRedirectService.showSpinner$;
    setTimeout(()=>{
      this.appRedirectService.closeSpinner();
      this.showSpinner$ = this.appRedirectService.showSpinner$;
    }, 3000);
    this.appRedirectService.triggerGoToApp();
  }

}
